import { Injectable, inject } from '@angular/core'

import { Observable } from 'rxjs'

import { WorkflowInstanceSummary } from '@flowx/designer/modules/integration-designer/models/workflow-instance.entity'
import {
  WorkflowApiService,
  WorkflowInstancesQueryParams,
} from '@flowx/designer/modules/integration-designer/services/workflow.api'
import { PaginationQueryParams } from '@flowx/designer/shared/api/api-http.service'
import { Application } from '@flowx/designer/shared/entities/application.entity'
import { GridSearchService } from '@flowx/designer/shared/services/grid-search.service'
import {
  PaginatedEndpoint,
  PaginatedResponse,
} from '@flowx/designer/shared/services/paginated-datasource'

@Injectable({ providedIn: 'root' })
export class WorkflowInstanceService extends GridSearchService<WorkflowInstanceSummary> {
  #workflowApiService = inject(WorkflowApiService)

  getGridEndpointInfo(): {
    endpoint: PaginatedEndpoint<any, WorkflowInstanceSummary>
    sort: { property: string; direction: 'asc' | 'desc' }
    query: Partial<any>
  } {
    return {
      endpoint: this.#getWorkflowInstances.bind(this),
      sort: null,
      query: {},
    }
  }

  #getWorkflowInstances(
    paginationParams: PaginationQueryParams,
    params: WorkflowInstancesQueryParams & { appId: Application['id'] }
  ): Observable<PaginatedResponse<WorkflowInstanceSummary>> {
    const { appId, ...queryParams } = params

    return this.#workflowApiService.getWorkflowInstances(appId, queryParams, paginationParams)
  }
}
